export default __webpack_public_path__ + "static/media/prizeIcon2.31bbf18b.png";